export default __webpack_public_path__ + "static/subscribe-banner-1-afa1fc36517439ce6ddab7ecd8fa6ee8.png";